<script setup>
import { onMounted, defineProps } from "vue";

const props = defineProps({
  type: {
    type: String,
    default: "1",
  },
  title: {
    type: String,
    default: "标题一",
  },
  subtitle: {
    type: String,
    default: "副标题",
  },
  imgUrl: {
    type: String,
    default: "",
  },
});

onMounted(() => {});
</script>

<template>
  <div class="home_card" :style="type === '1' ? 'flex-direction: row;' : 'flex-direction: row-reverse;'">
    <div class="home_card_l">
      <span data-aos="fade-up" class="home_card_l_title">{{ title }}</span>
      <span data-aos="fade-up" class="home_card_l_subtitle">{{ subtitle }}</span>
      <button data-aos="fade-up">{{ $t('home.mcardBtn') }}</button>
    </div>
    <div class="home_card_r">
      <img data-aos="fade-up" :src="imgUrl" alt="" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.home_card {
  padding: 40px 8%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  .home_card_l {
    width: 38%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .home_card_l_title {
      font-size: 36px;
      font-weight: bold;
      color: #000;
    }
    .home_card_l_subtitle {
      font-size: 24px;
      color: #333;
      padding: 40px 0;
    }
    button {
      cursor: pointer;
      font-size: 20px;
      color: #fff;
      width: 120px;
      height: 48px;
      border-radius: 50px;
      background: linear-gradient(270deg, #016afe 0%, #09dafd 100%);
    }
    button:hover {
      opacity: 0.8;
    }
  }
  .home_card_r {
    img {
      width: 532px;
      height: 564px;
    }
  }
}

@media (max-width: 768px) {
  .home_card { 
    padding: 20px 8%;
    flex-direction: column !important;
    .home_card_l {
      width: 100%;
      .home_card_l_title{
        font-size: 24px;
      }
      .home_card_l_subtitle{
        font-size: 20px;
        padding: 20px 0;
      }
      button{
        font-size: 15px;
        width: 100px;
        margin-bottom: 20px;
      }
    }
    .home_card_r {
      width: 100%;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
